<template>
    <div class="add-more">
        <template v-for="(item, index) in internalModel">
            <slot
                    name="default"
                    :item="item"
                    :index="index"
                    :input="handleItemInput"
                    v-if="typeof item === 'object' && !Array.isArray(item)"
            />
            <div
                    :key="index"
                    class="remove-wrapper"
                    v-if="typeof item === 'object' && !Array.isArray(item) && showRemove"
            >
                <slot
                        name="remove"
                        :remove="handleRemove"
                >
                    <b-link
                            href="javascript:void(0);"
                            class="remove-button font-weight-bold text-decoration-none text-danger h3"
                            @click="handleRemove(item,index)"
                    >
                        {{ removeText }}
                    </b-link>
                </slot>
            </div>
        </template>

        <div class="add-wrapper">
            <slot
                    name="add-more"
                    :add-more="handleAddMore"
                    :disabled="addMoreDisabled"
            >
                <b-button
                        @click="handleAddMore"
                        variant="secondary"
                        size="lg"
                        block
                        class="add-more bg-gray-100"
                        :disabled="addMoreDisabled"
                >
                    {{ addText }}
                </b-button>
            </slot>
        </div>
    </div>
</template>

<script>
    import './AddMore.scss';

    export default {
        name: "AddMore",
        components: {},
        props: {
            value: {
                type: Array,
                default: () => {
                    return [{}];
                },
                validator(value) {
                    let isValid = true;
                    for (let i = 0; i < value.length; i++) {
                        if (typeof value[i] !== 'object') {
                            isValid = false;
                            return;
                        }
                    }
                    return isValid;
                }
            },
            defaultValue: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            disabled: {
                type: Boolean,
                default: false
            },
            maxItems: {
                type: [String, Number],
                default: null,
                validator(value) {
                    if (value === null || parseInt(value) === 0) {
                        return true;
                    }
                    return Boolean(parseInt(value));
                }
            },
            addText: {
                type: String,
                default: '+ Add More'
            },
            removeText: {
                type: String,
                default: 'Remove'
            },
            noFirstItem: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                internalModel: Boolean(!this.value.length) && !this.noFirstItem ?
                    [Object.assign({}, this.defaultValue)] :
                    this.value,
            };
        },
        computed: {
            hasDefaultSlot() {
                return Boolean(this.$scopedSlots.default);
            },
            addMoreDisabled() {
                return !this.hasDefaultSlot || this.disabled || this.internalModel.length >= parseInt(this.maxItems);
            },
            showRemove() {
                return this.internalModel.length > 1;
            },
        },
        methods: {
            handleItemInput() {
                this.$emit('input', this.internalModel);
            },
            handleAddMore() {
                this.internalModel.push(Object.assign({}, this.defaultValue));
            },
            handleRemove(item, index) {
                this.internalModel.splice(index, 1);
                this.$emit('input', this.internalModel);
            },
        },
        watch: {
            value(newVal) {
                this.internalModel = newVal;
            }
        },
        mounted() {
            if (!this.$scopedSlots.default) {
                throw new Error('AddMore component requires content be provided in the default slot.');
            }

            if (this.internalModel.length > parseInt(this.maxItems)) {
                console.warn('AddMore component has more items than selected max.');
            }
        }
    };
</script>